import React, { useContext } from 'react';
import P from 'prop-types';
import { Button } from '../Button';
import { ExcluirDesativarConta } from '../../utils/api/api';
import { toast } from 'react-toastify';
import { RemoveUser } from '../../utils/utils';
import { GlobalContext } from '../../contexts/HomeContext';

export const ExcluirConta = ({ modalParam }) => {
  const { dadosApp, user, setUser, setEnderecos } = useContext(GlobalContext);

  const handleExcluirDesativar = async (excluir = false) => {
    const obj = { id: user.id, tipo_app: 'DELIVERY', excluir: excluir };

    const response = await ExcluirDesativarConta(obj);

    if (response.data.status === 0) {
      const title = excluir ? 'excluída' : 'desativada';
      toast.success('Conta ' + title + ' com sucesso!');
      modalParam.closeCadastro();
      RemoveUser(dadosApp.IdLoja, setUser, setEnderecos);
    } else if (response.data.status === 1) {
      toast.error(response.data.msg, { containerId: 'modalToast' });
      return;
    }

    if (response.data.Retorno) {
      if (response.data.Retorno.status == 1) {
        toast.error(response.data.Retorno.msg, { containerId: 'modalToast' });
        return;
      }
      const title = excluir ? 'excluída' : 'desativada';
      toast.success('Conta ' + title + ' com sucesso!');
      modalParam.closeCadastro();
      RemoveUser(dadosApp.IdLoja, setUser, setEnderecos);
    }
  };

  return (
    <div className={'modal-content-dialog'}>
      <div className={'form-group'} style={{ marginBottom: 20 }}>
        <p className="padBottom20" style={{ marginBottom: 20, textAlign: 'center' }}>
          Desativar sua conta ao invés de excluí-la?
        </p>
        <div className="form-group-col2" style={{ gridTemplateColumns: '0.1fr 1fr', alignItems: 'center' }}>
          <i className="material-icons">person_off</i>
          <p style={{ fontSize: 14, fontWeight: 'bold', marginTop: 3 }}>A desativação é temporária</p>
        </div>
        <p style={{ marginBottom: 30, marginTop: 10, fontSize: 14 }}>
          Seus dados e histórico de pedidos ficarão ocultos e não será possível realizar pedidos até que você reative a
          conta novamente.
        </p>

        <div className="form-group-col2" style={{ gridTemplateColumns: '0.1fr 1fr', alignItems: 'center' }}>
          <i className="material-icons">warning_amber</i>
          <p style={{ fontSize: 14, fontWeight: 'bold', marginTop: 3 }}>A exclusão é permanente</p>
        </div>
        <p style={{ marginBottom: 30, marginTop: 10, fontSize: 14 }}>
          Todos os seus dados e histórico de pedidos serão excluídos permanentemente.
        </p>
      </div>

      <div className="padTop20 padBottom20">
        <Button
          text="Desativar Conta"
          className="btn_1 btnGradient width-full clearfix"
          onClick={() => handleExcluirDesativar(false)}
        />
      </div>

      <div className="padTop20 padBottom20">
        <div className="info-green">
          <a href="#" onClick={() => handleExcluirDesativar(true)}>
            Excluir Conta
          </a>
        </div>
      </div>
    </div>
  );
};

ExcluirConta.propTypes = {
  modalParam: P.object,
};
